<template lang="html">

  <div id="topbar" class="topbar container-fluid darkBackground">
    <div class="col-xs-11 col-sm-10 col-lg-8 no-left-gutter">

      <div class="col-xs-1 topbar__toggle">
        <a href="#">
          <img class="topbar__icon topbar__icon--drawer-w23" :src="$getImagePath('images', 'icon_drawer_w23.svg')" @click.prevent="toggleNavigation()" v-if="!navigationVisible" :alt="topbar.open" :title="topbar.open">
          <img class="topbar__icon" :src="$getImagePath('images', 'icon_close.svg')" @click.prevent="toggleNavigation()" v-if="navigationVisible" :alt="topbar.close" :title="topbar.close">
        </a>
      </div>

      <!-- Search -->
      <div class="col-xs-12 col-sm-10 col-sm-offset-1 topbar__search">
        <sw-search
          @closeNav="closeNavigation()"
          v-if="searchVisible"></sw-search>
        <div
          class="topbar__slogan"
          v-if="sloganVisible">{{ $getTrans('slogan', 'de') }}
          <i class="topbar__slogan-icon__search fa fa-search" aria-hidden="true"></i>
        </div>
      </div>
      <!--// Search -->

      <ul class="iconbar">
        <li
          class="iconbar__img"
          v-for="(item, key, index) in socialLinks"
          v-if="item.active==1"
          >
          <a
            :href="item.url"
            :target="item.target"
            >
            <img
              :src="$getImagePath('images', 'icon_'+item.type+'.svg')"
              :alt="item.type"
              >
          </a>
        </li>
      </ul>

    </div>

    <div v-if="navigationVisible">
      <sw-navigation
        :navitems="computedNav"
        :navactive="navactive"
        @closeNav="getChildData()"></sw-navigation>
    </div>

    <div class="col-xs-1 col-xs-offset-0 col-lg-offset-2">
      <div id="flag" class="flag col-lg-6 col-md-10 col-sm-12 hidden-xs col-lg-offset-6">
        <div class="flag__container">
          <router-link to="/" active-class="expanded" @click.native="emitClick()" exact>
            <img :src="$getImagePath('images', 'wfv_logo.svg')">
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api'
import EventBus from '@/eventbus'

import Navigation from '@/components/includes/Navigation'
import Search from '@/components/search/Search'
import staticData from '@/data/cms.json'

export default {
  name: 'Topbar',
  components: {
    'sw-navigation': Navigation,
    'sw-search': Search
  },
  data() {
    return {
      navigationVisible: false,
      socialLinks: this.$root.StaticData.sociallinks,
      translations: this.$root.StaticData.translations,
      topbar: {
        open: this.getTranslation('open'),
        close: this.getTranslation('close')
      },
      region: null,
      navactive: false,
      searchVisible: false,
      sloganVisible: true,
      local: true,
      dbDevelop: null,
      dbProduction: null
    }
  },
  watch: {
    '$route.params.region': function(region) {
      this.getRegion()
    }
  },
  mounted () {
    // console.log('Topbar.vue')
    this.getRegion()

    // Listen only for the first emission of the event
    EventBus.$once('showSearch', this.displaySearch)
  },
  destroyed () {
    // Stop listening.
    EventBus.$off('showSearch', this.displaySearch)
  },
  methods: {
    getRegion () {
      let region = this.$route.params.region
      let region1 = this.$root.$data.region
      if(region) {
        region = `/${region.toLowerCase()}`
      }
      this.region = region
      // console.log('region: ', region)
    },
    getTranslation (string) {
      return this.$getTrans(string)
    },
    toggleNavigation () {
      this.navigationVisible = !this.navigationVisible
      if(this.navigationVisible)
        EventBus.$emit('closeSearch', true)
    },
    getChildData () {
      this.toggleNavigation()
    },
    closeNavigation () {
      this.navigationVisible = false
      this.navactive = true
    },
    displaySearch () {
      this.sloganVisible = !this.sloganVisible
      this.searchVisible = !this.searchVisible
    },
    emitClick () {
      // nothing at the moment
    }
  },
  computed: {
    computedNav () {
      return this.$root.$data.navitems
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/includes/Topbar.vue